<template>
  <CheckupsOverview />
</template>

<script lang="ts">
import Vue from "vue";
import CheckupsOverview from "@/components/checkups/container/CheckupsOverview.vue";

export default Vue.extend({
  components: {
    CheckupsOverview,
  },
});
</script>
